// import React from "react";
// import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

// // Function to determine stroke color based on value change
// const getColor = (data, index) => {
//   if (index === 0) return "#00ff00"; // Start with green
//   if(data) {
//     return Number(data[index].betAmount) > Number(data[index - 1].betAmount) ? "#00ff00" : "#ff0000";

//   }
// };

// export const CustomLineChart = (props) => {
//   return (
//     <ResponsiveContainer width="100%" height={150}>
//       <LineChart data={props?.data}>
//         <XAxis dataKey="betAmount" />
//         <YAxis />       
//         {props?.data?.map((entry, index) => (
//           <Line
//             key={index}
//             type="monotone"
//             dataKey="betAmount"
//             stroke={getColor(props.data, index)}
//             strokeWidth={2}
//           />
//         ))}
//       </LineChart>
//     </ResponsiveContainer>
//   );
// };

import React, { useEffect, useState } from "react";
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceLine } from "recharts";

const data = [
  { time: "10:00", value: -50 },
  { time: "10:30", value: -80 },
  { time: "11:00", value: -120 },
  { time: "11:30", value: -40 },
  { time: "12:00", value: 20 },
  { time: "12:30", value: 50 },
  { time: "11:00", value: -120 },
  { time: "11:30", value: -40 },
  { time: "01:00", value: 30 },
  { time: "01:30", value: 70 },
  { time: "12:00", value: 20 },
  { time: "12:30", value: 50 },
];

// Split positive and negative values
const positiveData = data.map((point) => ({
  x: point.x,
  y: point.y > 0 ? point.y : 0,
}));

const negativeData = data.map((point) => ({
  x: point.x,
  y: point.y < 0 ? point.y : 0,
}));

// Split positive and negative values
const processData = (data) =>
  data.map((item) => ({
    ...item,
    positive: item.value > 0 ? item.value : 0,
    negative: item.value < 0 ? item.value : 0,
  }));


export const LineChartWithArea = () => {

  const processedData = processData(data);

  const [width, setWidth] = useState(650);
  const [height, setHeight] = useState(300);

  useEffect(() => {
    let responsiveWidth = window.innerWidth;
    if (responsiveWidth > 1200) {
      // Desktop
      setWidth(650);
      setHeight(300);
    } else if (responsiveWidth > 900) {
      // Desktop
      setWidth(650);
      setHeight(300);
    } else if (responsiveWidth >= 768) {
      // Laptop
      setWidth(550);
      setHeight(300);
    } else if (responsiveWidth > 480) {
      // Tablet
      setWidth(350);
      setHeight(300);
    } else {
      // Mobile
      setWidth(350);
      setHeight(300);
    }
  }, [])

  return (
    <ResponsiveContainer width="100%" height={400}>
    <AreaChart data={processedData}>
      <defs>
        {/* Gradient for Negative Values (Red) */}
        <linearGradient id="negativeGradient" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="red" stopOpacity={0.7} />
          <stop offset="100%" stopColor="black" stopOpacity={0.3} />
        </linearGradient>

        {/* Gradient for Positive Values (Green) */}
        <linearGradient id="positiveGradient" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="green" stopOpacity={0.7} />
          <stop offset="100%" stopColor="black" stopOpacity={0.3} />
        </linearGradient>
      </defs>

      {/* <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="time" />
      <YAxis /> */}
      <Tooltip />

      {/* Zero Line (Reference Line) */}
      <ReferenceLine y={0} stroke="white" strokeWidth={1} />

      {/* Negative Values (Below Axis) */}
      <Area
        type="monotone"
        dataKey="negative"
        stroke="red"
        fill="url(#negativeGradient)"
        strokeWidth={2}
        isAnimationActive={true}
        connectNulls
      />

      {/* Positive Values (Above Axis) */}
      <Area
        type="monotone"
        dataKey="positive"
        stroke="green"
        fill="url(#positiveGradient)"
        strokeWidth={2}
        isAnimationActive={true}
        connectNulls
      />
    </AreaChart>
  </ResponsiveContainer>
  );
}


